import { observer } from "mobx-react-lite"
import React, { useState } from "react"
import { TextInput, type TextInputProps } from "@mantine/core"
import { CourseService } from "../../app/services"

// ----------------------------------------------------------------------

export const CourseSearch: React.FC<TextInputProps> = observer(function CourseSearch(props) {
  const [ searchTimeout, setSearchTimeout ] = useState<ReturnType<typeof setTimeout>>()
  const [ value, setValue ] = useState<string>("")

  const handleSearch = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setValue(target.value)

    if (searchTimeout) clearTimeout(searchTimeout)
    setSearchTimeout(setTimeout((search) => CourseService.setSearchParam("search", search), 500, target.value))
  }

  return (
    <TextInput
      value={value}
      onChange={handleSearch}
      placeholder="Общая нутрициология"
      {...props}
    />
  )
})
